import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom';
import { resendOTP as resendOTPAPI} from 'services/apiAuth1'

const useResendCode = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    
    const {isPending:isResending,mutate: resendOTP} = useMutation({
        mutationFn:(data)=> resendOTPAPI(data),
        onSuccess:(data)=>{
            toast.success("Code sent Successfully",{id:'resend-otp'})
        },
        onError:(error)=>{
            console.log("resend error:", error);

            if (error?.status === 400 || error?.status === 404) {
                const message = error?.data?.message ?? "Session expired. Please log in again.";
                toast.error(message, { id: 'resend-otp' })

                queryClient.removeQueries({ queryKey: ['mfa-session'] })
                localStorage.removeItem('loginData')

                setTimeout(() => {
                    navigate('/login', { replace: true })
                }, 1500) // small delay so the user actually reads the toast

                return;
            }
            
            if (error?.data && typeof error.data === 'object'){
                for (const key in error.data) {
                const messages = error.data[key]
                const message = Array.isArray(messages) ? messages[0] : messages
                toast.error(message,{id:'resend-otp'})
                }
            }else{
                toast.error("Something went wrong. Please try again.",{id:'resend-otp'})
            }
        }
    })
    return {isResending,resendOTP}
}

export default useResendCode
